// extracted by mini-css-extract-plugin
export default {"container":"menu__container___ql90l","menuVertical":"menu__menuVertical___NRhsv"};